import { render } from "./ViewMenu.vue?vue&type=template&id=7a637564&scoped=true"
import script from "./ViewMenu.vue?vue&type=script&lang=js"
export * from "./ViewMenu.vue?vue&type=script&lang=js"

import "./ViewMenu.vue?vue&type=style&index=0&id=7a637564&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a637564"]])

export default __exports__